/* import __COLOCATED_TEMPLATE__ from './search-result-entries.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./search-result-entries.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: ""
}));